export default __webpack_public_path__ + "static/media/im-placeholder-attached-photo.fb643603.svg";